import { createContext } from 'react';
import type { PublishedStatement } from '@peruselab/api-client/molecules';

/**
 * #947 phase 2: Correct and Withdraw on your own statements -- provided where statements can be
 * edited (a statement section), absent elsewhere.
 */
export const StatementEditing = createContext<{
  readonly onCorrect?: (statement: PublishedStatement) => void;
  readonly onWithdraw?: (statement: PublishedStatement) => void;
}>({});
